// @tennis-matches/services/governance
// Vereinfachtes Tenant-Rollenmodell (Admin-Einladungen, Rollenvergabe, RPC-Allowlist).

function __asStr(v) {
  return String(v ?? "")
    .trim()
    .toLowerCase();
}

/** Kanonische Tenant-Rollen (Reihenfolge für UI). */
export const TENANT_ASSIGNABLE_ROLE_IDS = Object.freeze([
  "vereinsadmin",
  "trainer",
  "trainer_coordinator",
  "player",
]);

/** Nicht über Vereins-UI vergebbar: matchflow_operator (nur MatchFlow-Assignment-Sync). */

export const TENANT_ASSIGNABLE_ROLE_OPTIONS = Object.freeze(
  TENANT_ASSIGNABLE_ROLE_IDS.map((role) => {
    if (role === "vereinsadmin")
      return { role, labelKey: "onboarding.roles.vereinsadmin" };
    if (role === "trainer")
      return { role, labelKey: "onboarding.roles.trainer" };
    if (role === "trainer_coordinator")
      return { role, labelKey: "onboarding.roles.trainerCoordinator" };
    return { role, labelKey: "onboarding.roles.player" };
  }),
);

const ASSIGNABLE_SET = new Set(TENANT_ASSIGNABLE_ROLE_IDS);

/** @param {unknown[]} roles */
export function sanitizeTenantAssignableRoles(roles) {
  const out = [];
  const seen = new Set();
  for (const r of Array.isArray(roles) ? roles : []) {
    const x = __asStr(r);
    if (!x || !ASSIGNABLE_SET.has(x) || seen.has(x)) continue;
    seen.add(x);
    out.push(x);
  }
  return out;
}
